import React from 'react';
import cn from 'classnames';
import { dtm } from 'utils/analytics';
import { i18n } from 'utils/i18n';
import ANALYTICS from 'constants/analytics';
import LOCATIONS from 'constants/locations';
import Button from 'components/Button';
import SoldOutTileBanner from '../SoldOutTileBanner';

const LocationDetailTile = ({
  onSelectLocation,
  isReservationFlow,
  handleSelectedLocation,
  handleAdjustDateTime,
  handleExpandLocation,
  activeMarker,
}) => {
  const {
    brand,
    location_type,
    name,
    label,
    address: { street_addresses },
    additional_data: { formatted_city_state_zip },
    locationData,
    isSoldOut,
  } = activeMarker;

  const address = street_addresses.join(', ');
  const isPartner = brand !== LOCATIONS.BRAND_ALAMO;
  const partnerLocationHashMap = {
    [LOCATIONS.BRAND_ENTERPRISE]: i18n('common_enterprise_long_name'),
    [LOCATIONS.BRAND_NATIONAL]: i18n('common_national_long_name'),
  };

  return (
    <div className='map-location-detail-tile component-theme--light'>
      <div
        className={cn('map-location-detail-tile__container', {
          'map-location-detail-tile__container--sold-out': isSoldOut,
        })}
      >
        <Button
          plain
          className='map-location-detail-tile__close-button'
          title={i18n('no_results_partner_close')}
          onClick={handleSelectedLocation}
          aria-label={i18n('no_results_partner_close')}
        ></Button>
        <div
          className={cn('map-location-detail-tile__info-section', {
            'map-location-detail-tile__info-section--sold-out': isSoldOut,
          })}
        >
          <div className='map-location-detail-tile__name-info'>
            <span className='map-location-detail-tile__index-number'>{label.text}</span>
            <h2 className='map-location-detail-tile__main-title'>{name}</h2>
          </div>
          {isPartner && <p className='map-location-detail-tile__sub-title'>{partnerLocationHashMap[brand]}</p>}
          <div className='map-location-detail-tile__location-section'>
            <span
              className={cn(
                'map-location-detail-tile__icon',
                `map-location-detail-tile__icon--${isPartner ? brand : location_type}`,
                {
                  'map-location-detail-tile__icon--sold-out': isSoldOut,
                }
              )}
            />
            <div className='map-location-detail-tile__address'>
              <p>{address}</p>
              <p>{formatted_city_state_zip}</p>
            </div>
          </div>
        </div>
        {isSoldOut && <SoldOutTileBanner />}
        <div className={cn('map-location-detail-tile__actions-section map-location-detail-tile__show-line')}>
          {isReservationFlow && !isPartner ? (
            <Button
              className={cn('map-location-detail-tile__link', {
                'map-location-detail-tile__link--sold-out': isSoldOut,
              })}
              onClick={isSoldOut ? handleAdjustDateTime : onSelectLocation(locationData)}
              data-dtm-track={dtm(
                ANALYTICS.UI_BUTTON,
                ANALYTICS.LOCATION_ID(locationData.id),
                isSoldOut ? ANALYTICS.ADJUST : ANALYTICS.SELECT
              )}
              inverse={isSoldOut}
              ariaText={`${isSoldOut ? i18n('common_adjust') : i18n('map_locations_tile_link_text')} ${name}`}
            >
              {isSoldOut ? i18n('common_adjust') : i18n('map_locations_tile_link_text')}
            </Button>
          ) : (
            <a
              href={'#'}
              onClick={onSelectLocation(locationData)}
              className={cn('button', 'map-location-detail-tile__link', {
                'map-location-detail-tile__partner-button': isPartner,
              })}
              rel='noopener noreferrer'
              target={`${isPartner ? '_blank' : ''}`}
              data-dtm-track={dtm(ANALYTICS.UI_BUTTON, ANALYTICS.LOCATION_ID(locationData.id), ANALYTICS.SELECT)}
            >
              {i18n(!isPartner ? 'map_locations_tile_link_text' : 'no_results_partner_tile_link_text')}
            </a>
          )}
          {!isPartner && (
            <Button
              plain
              type='button'
              className={cn('link map-location-detail-tile__expand-details--expanded')}
              aria-label={i18n('map_locations_tiles_expand_button')}
              onClick={handleExpandLocation}
              data-dtm-track={`button|location_${locationData.id}|details`}
            >
              {i18n('map_locations_tiles_expand_button')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocationDetailTile;
